// extracted by mini-css-extract-plugin
export default {"input":"awF71P","noCross":"bwF71P","wrapper":"cwF71P","external":"dwF71P","autoCompletePlaceholder":"ewF71P","inputCross":"fwF71P","crossButton":"gwF71P","inputWrapper":"hwF71P"};